/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
// components/Counter.tsx
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { RootState } from "../store/reducers";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { useTranslation, withTranslation } from "react-i18next";
import HomeBanner from "../components/HomeBanner/HomeBanner";
import StoreList from "../components/storeList/StoreList";

const HomeScreen = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const appState = useSelector((state: RootState) => state.appReducer);
  const { paymentMethodPopUp, langValue, freezScreen }: any = appState;
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeId, storeInfo } = apiState;

  const onLanguageHandle = () => {
    i18n.changeLanguage(langValue);
    localStorage.setItem("Language", JSON.stringify(langValue));
  };
  useEffect(() => {
    onLanguageHandle();
  }, [langValue]);


  const [, setScroll]: any = useState(false);
  useEffect(() => {
    const scrolling = () => {
      const handleScroll = () => {
        setScroll(window.scrollY > 0);
      };

      window.addEventListener("scroll", handleScroll);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };

    scrolling();
  }, []);

  return freezScreen ? (
    <div>
      <Skeleton variant="rounded" width={`100%`} height={200} />
      <Skeleton width={`50%`} height={80} />
      <Skeleton className="my-4" variant="rounded" width={`100%`} height={180} />
      <Skeleton className="my-4" variant="rounded" width={`100%`} height={180} />
      <Skeleton className="my-4" variant="rounded" width={`100%`} height={180} />
    </div>
  ) : (
    <React.Fragment>
      {storeInfo && <HomeBanner />}
      <div className="px-2">
        <div
          id="SteperMain"
          className={` ${
            langValue === "ar" ? `directionRt classForArabicReOrderMain` : ""
          } ${langValue == "ar" ? "arabicFamilyParent" : " "}`}
        >
          <div
            className={`mt-4 d-flex align-items-center justify-content-between ${
              appState.langValue === "ar" ? " direction-rtl" : "direction-ltr"
            }`}
          >
            <h3
              className={`mainHeading familysora600 mx-2 mb-0 text-center ${
                appState?.langValue === "ar" ? `` : ``
              }`} 
            >
              {t("home.Select-your-occasion")}
            </h3>
          </div>
        </div>
        <StoreList />
        <div className="my-4 py-4" />
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(HomeScreen);
